import { render, staticRenderFns } from "./ComponentEditablePropertyToggle.vue?vue&type=template&id=49587f47&"
import script from "./ComponentEditablePropertyToggle.vue?vue&type=script&lang=ts&"
export * from "./ComponentEditablePropertyToggle.vue?vue&type=script&lang=ts&"
import style0 from "./ComponentEditablePropertyToggle.vue?vue&type=style&index=0&id=49587f47&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports